import React, { useState } from "react";
import { DatePicker as MobileDatePicker } from "antd-mobile";
import { anchorWallDate, utcIsoToWallDate, utcToLocalDateTime, wallDateToUtcIso } from "./rampChecklistTime";

const labelRenderer = (type, data) => {
    switch (type) {
        case "year":
            return `${data}年`;
        case "month":
            return `${data}月`;
        case "day":
            return `${data}日`;
        case "hour":
            return `${data}时`;
        case "minute":
            return `${data}分`;
        default:
            return data;
    }
};

/**
 * 移动端日期时间选择器：点触发文本弹出 antd-mobile 滚轮式 DatePicker（年-月-日-时-分），
 * 比桌面日历弹窗更适合手机点按。值按过站机场当地"墙上时间"展示与录入、对外存 UTC ISO（秒级）。
 */
export default function MobileDateTimePicker({ value, onChange, tzId, anchorDate, placeholder = "点击填写", disabled = false, allowClear = true }) {
    const [visible, setVisible] = useState(false);
    const display = value ? utcToLocalDateTime(value, tzId, "MM-DD HH:mm") : "";

    return (
        <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
            <span
                role="button"
                tabIndex={disabled ? -1 : 0}
                onClick={() => !disabled && setVisible(true)}
                style={{
                    cursor: disabled ? "default" : "pointer",
                    color: display ? "#1a1a1a" : "#bbb",
                    borderBottom: disabled ? "1px solid transparent" : "1px dashed #d9d9d9",
                    padding: "2px 0",
                    minWidth: 92,
                    textAlign: "center",
                    userSelect: "none",
                }}
            >
                {display || placeholder}
            </span>
            {allowClear && value && !disabled && (
                <span onClick={() => onChange(null)} style={{ cursor: "pointer", color: "#bbb", fontSize: 15, lineHeight: 1 }} aria-label="清除">
                    ×
                </span>
            )}
            <MobileDatePicker
                title="选择时间"
                confirmText="确定"
                cancelText="取消"
                visible={visible}
                onClose={() => setVisible(false)}
                precision="minute"
                value={utcIsoToWallDate(value, tzId)}
                defaultValue={anchorWallDate(anchorDate)}
                renderLabel={labelRenderer}
                onConfirm={(date) => onChange(wallDateToUtcIso(date, tzId))}
            />
        </span>
    );
}
